import { ToastrService } from "ngx-toastr";
import { Injectable } from "@angular/core";
import { TranslateService } from "app/modules/shared/services/translate/translate.service";

@Injectable()
export class ToastService {
  constructor(
    private toastService: ToastrService,
    private translateService: TranslateService
  ) {}

  toastSuccess(message = "success_message", timeout = 5000) {
    const msg = this.translateService.instant(message);
    const title = "";
    this.toastService.success(msg, title, {
      timeOut: timeout,
    });
  }

  toastError(message = "error_message", timeout = 5000) {
    const msg = this.translateService.instant(message);
    const title = "";
    this.toastService.error(msg, title, {
      timeOut: timeout,
    });
  }

  toastInfo(message: any, payload?: any, timeout = 5000) {
    const msg = payload + this.translateService.instant(message);
    const title = "";
    this.toastService.info(msg, title, {
      timeOut: timeout,
    });
  }
}
